import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { layoutQuery } from "#modules/layouts/infra/layout.query";
import { quoteRequestLineQuery } from "#modules/quoteRequestLines/infra/quoteRequestLine.query";
import { NestingRunView } from "shared";

import { applyLayoutNesting } from "../infra/applyLayoutNesting.api";
import { setLayoutNestingQueryData } from "../infra/layoutNesting.query";

export const useApplyLayoutNesting = (
  layoutId: string,
  quoteRequestLineId: string | null,
  options?: { onSuccess?: () => void; onError?: (err: unknown) => void },
) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation<NestingRunView>({
    mutationFn: () => applyLayoutNesting(layoutId),
    onSuccess: async (nestingRun) => {
      setLayoutNestingQueryData(queryClient, layoutId, nestingRun);
      await queryClient.invalidateQueries(layoutQuery(layoutId));
      if (quoteRequestLineId) {
        await queryClient.invalidateQueries(quoteRequestLineQuery({ id: quoteRequestLineId }));
      }
      options?.onSuccess?.();
    },
    onError: (err: unknown) => {
      options?.onError?.(err);
      errorHandler(err);
    },
  });

  return { applyLayoutNesting: mutate, ...rest };
};
